import { AUDIENCES_ZOOM_WITH_EXPERT_URL } from 'constants/urls';
import ProPlanView from './ProPlan.View';

const ProPlan = () => {
  const onSubmit = () => window.open(AUDIENCES_ZOOM_WITH_EXPERT_URL, '_blank', 'noreferrer');
  return <ProPlanView onSubmit={onSubmit} />;
};

export default ProPlan;
